import "../styles/globals.css";
import { ThemeProvider } from "next-themes";
import Layout from "../components/layout";
import { Provider } from "react-redux";
import { store } from "../redux/store";
import { useRouter } from "next/router";
import Meta from "../components/Meta";
import UserContext from "../components/UserContext";
import { useRef } from "react";
import { SeiWalletProvider } from "@sei-js/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const devConfig = {
  chainId: "atlantic-2",
  restUrl: "https://rest.atlantic-2.seinetwork.io",
  rpcUrl: "https://rpc.atlantic-2.seinetwork.io",
};

const mainConfig = {
  chainId: "pacific-1",
  restUrl: "https://sei-api.polkachu.com",
  rpcUrl: "https://rpc.nut.market/",
  // rpcUrl: "https://rpc.ankr.com/sei",
  // rpcUrl: "https://sei-rpc.polkachu.com",
};

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const pid = router.asPath;
  const scrollRef = useRef({
    scrollPos: 0,
  });

  return (
    <>
      {/* <h1 style={{textAlign: "center", marginTop: "100px"}}>Site under Maintenance</h1> */}
      <Meta title="Home" />

      <Provider store={store}>
        <ThemeProvider
          enableSystem={true}
          attribute="class"
          defaultTheme="dark"
        >
          <SeiWalletProvider
            chainConfiguration={mainConfig}
            wallets={["compass", "fin"]}
            autoConnect={"compass"}
          >
            <UserContext.Provider value={{ scrollRef: scrollRef }}>
              <ToastContainer />
              {pid === "/login" ? (
                <Component {...pageProps} />
              ) : (
                <Layout>
                  <Component {...pageProps} />
                </Layout>
              )}
            </UserContext.Provider>
          </SeiWalletProvider>
        </ThemeProvider>
      </Provider>
    </>
  );
}

export default MyApp;
